module.exports = __webpack_public_path__ + "static/media/graphql.bfc2b89c.svg";